import React, { useState } from "react";
import { useQuery, useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";
import DataTable from "../../../components/shared/DataTable";
import Modal from "../../../components/shared/Modal";
import { formatDate, statusBadgeClass } from "../../../utils/helpers";
import api from "../../../utils/api";

export default function Issues() {
  const queryClient = useQueryClient();
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({ subject: "", description: "", bookingId: "" });

  const { data, isLoading } = useQuery("patient-issues", () =>
    api.get("/patient/issues")
  );

  const submitMutation = useMutation(
    () => api.post("/patient/issues", form),
    {
      onSuccess: () => {
        queryClient.invalidateQueries("patient-issues");
        toast.success("Issue raised. We'll get back to you soon.");
        setShowModal(false);
        setForm({ subject: "", description: "", bookingId: "" });
      },
    }
  );

  const columns = [
    { key: "subject", label: "Subject" },
    {
      key: "createdAt",
      label: "Date",
      render: (row) => formatDate(row.createdAt),
      sortable: true,
    },
    {
      key: "status",
      label: "Status",
      render: (row) => (
        <span className={statusBadgeClass(row.status)}>{row.status}</span>
      ),
    },
    { key: "lastMessage", label: "Last Reply" },
  ];

  return (
    <div className="space-y-4">
      <div className="flex justify-end">
        <button onClick={() => setShowModal(true)} className="btn-primary">
          + Raise Issue
        </button>
      </div>

      <DataTable
        columns={columns}
        data={data?.issues || []}
        loading={isLoading}
        emptyMessage="No issues raised."
      />

      <Modal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        title="Raise an Issue"
        footer={
          <>
            <button onClick={() => setShowModal(false)} className="btn-secondary">Cancel</button>
            <button
              onClick={() => submitMutation.mutate()}
              disabled={submitMutation.isLoading}
              className="btn-primary"
            >
              {submitMutation.isLoading ? "Submitting…" : "Submit"}
            </button>
          </>
        }
      >
        <div className="space-y-4">
          <div>
            <label className="block text-xs font-semibold text-slate-500 mb-1.5 uppercase tracking-wide">Subject</label>
            <input
              type="text"
              value={form.subject}
              onChange={(e) => setForm((f) => ({ ...f, subject: e.target.value }))}
              className="input-field"
              required
            />
          </div>
          <div>
            <label className="block text-xs font-semibold text-slate-500 mb-1.5 uppercase tracking-wide">Booking ID (optional)</label>
            <input
              type="text"
              value={form.bookingId}
              onChange={(e) => setForm((f) => ({ ...f, bookingId: e.target.value }))}
              className="input-field"
            />
          </div>
          <div>
            <label className="block text-xs font-semibold text-slate-500 mb-1.5 uppercase tracking-wide">Description</label>
            <textarea
              value={form.description}
              onChange={(e) => setForm((f) => ({ ...f, description: e.target.value }))}
              rows={4}
              className="input-field resize-none"
              required
            />
          </div>
        </div>
      </Modal>
    </div>
  );
}
